// «К содержимому» (задача D5, ui-spec §6): первая остановка Tab — ссылка мимо меню прямо в рабочую панель `#main`.
// Видна только в фокусе.
export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only rounded-md bg-card px-3 py-2 text-base font-medium text-foreground shadow-pop focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-60"
    >
      К содержимому
    </a>
  );
}
